// Nasıl oynanır? — lobide çıkan 6 adımlı Batak yönergesi (domino/ludo/umo/
// tavla kalıbının React uyarlaması, üç modu da anlatır).
// İlk açılışta otomatik gösterilir (localStorage batak_tutorial_seen);
// "Geç" bu oturumda geçer, "Bir daha gösterme" veya sonuna kadar izlemek
// kalıcı kapatır. Bileşen başlatıcı butonu da kendisi çizer.
import { useState, useEffect } from 'react';

const SEEN_KEY = 'batak_tutorial_seen';

const seen = () => {
    try { return localStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return true; }
};
const markSeen = () => {
    try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
};

// Mini iskambil kartı (CSS) — suit: '♠♥♦♣', red = kırmızı renk
const Card = ({ rank, suit, cls = '' }) => (
    <span className={`btCard ${'♥♦'.includes(suit) ? 'red' : ''} ${cls}`}>
        <b>{rank}</b>
        <i>{suit}</i>
    </span>
);

const Back = () => <span className="btCard back" />;

const STEPS = [
    {
        title: 'Les enchères',
        text: 'Regarde ton jeu et annonce combien de levées tu peux faire. La plus haute enchère emporte le contrat : 8 minimum en équipe et avec écart, 5 en solo.',
        scene: (
            <>
                <div className="btRow">
                    <span className="btBubble">8</span>
                    <span className="btBubble dim">PASSE</span>
                    <span className="btBubble win">9</span>
                </div>
                <div className="btBadge">La plus haute enchère l’emporte</div>
            </>
        ),
    },
    {
        title: 'Le choix de l’atout',
        text: 'Le preneur choisit l’atout. La logique est simple : prends la couleur où tu as le PLUS de cartes et les grosses (A, K) — l’atout coupe toutes les autres couleurs !',
        scene: (
            <>
                <div className="btRow suits">
                    <span className="btSuit win">♠</span>
                    <span className="btSuit red">♥</span>
                    <span className="btSuit red">♦</span>
                    <span className="btSuit">♣</span>
                </div>
                <div className="btRow">
                    <Card rank="A" suit="♠" cls="glow" />
                    <Card rank="K" suit="♠" cls="glow" />
                    <Card rank="Q" suit="♠" cls="glow" />
                    <Card rank="7" suit="♠" cls="glow" />
                    <Card rank="3" suit="♥" cls="dim" />
                </div>
                <div className="btBadge">4 piques + A-K = atout pique</div>
            </>
        ),
    },
    {
        title: 'Le jeu',
        text: 'Tu DOIS fournir la couleur demandée — et même monter si tu peux. Sans cette couleur, tu dois couper, et surmonter l’atout déjà posé si tu le peux. La plus forte carte (ou le plus fort atout) remporte la levée.',
        scene: (
            <>
                <div className="btRow">
                    <Card rank="7" suit="♥" />
                    <Card rank="K" suit="♥" />
                    <Card rank="9" suit="♥" />
                    <Card rank="3" suit="♠" cls="glow" />
                </div>
                <div className="btBadge">Plus de cœur → même un petit atout emporte la levée</div>
            </>
        ),
    },
    {
        title: 'Chute & points',
        text: 'Si le preneur ne fait pas son contrat, il CHUTE : il perd autant de points que son annonce. S’il réussit, ses levées comptent. Un match dure 3 manches ; le gagnant est déterminé au TOTAL des 3 manches.',
        scene: (
            <>
                <div className="btRow">
                    <span className="btScore bad">−9 chute</span>
                    <span className="btScore good">+9 réussi</span>
                </div>
                <div className="btRow">
                    <span className="btBadge">Match en 3 manches · le total décide</span>
                </div>
                <div className="btBadge gold">🪙 Le gagnant rafle la mise</div>
            </>
        ),
    },
    {
        title: 'Équipe & Solo',
        text: 'En équipe : 4 joueurs, ton partenaire est en face ; enchère 8+ et après la prise son jeu est VISIBLE. Solo : 4 joueurs, chacun pour soi ; enchère 5+ et on ne peut pas entamer atout tant qu’il n’est pas coupé.',
        scene: (
            <>
                <div className="btRow seats">
                    <span className="btSeat teamA">👤</span>
                    <span className="btSeat teamB">👤</span>
                    <span className="btSeat teamA">👤</span>
                    <span className="btSeat teamB">👤</span>
                </div>
                <div className="btRow labels">
                    <span className="lblA">équipe bleue</span>
                    <span className="lblB">équipe rouge</span>
                </div>
            </>
        ),
    },
    {
        title: 'Avec écart',
        text: '3 joueurs, 16 cartes chacun, 4 cartes cachées à l’ÉCART. Le preneur ramasse l’écart (20 cartes en main), en écarte 4, puis choisit l’atout. Personne ne voit les cartes écartées !',
        scene: (
            <>
                <div className="btRow stack">
                    <Back /><Back /><Back /><Back />
                </div>
                <div className="btRow">
                    <span className="btArrow">⤵</span>
                    <span className="btBadge">prends l’écart → écarte 4 cartes → choisis l’atout</span>
                </div>
            </>
        ),
    },
];

const CSS = `
#batakTut{position:fixed;inset:0;z-index:10005;display:flex;align-items:center;justify-content:center;background:rgba(4,6,18,.82);font-family:inherit;padding:18px}
#batakTut .btPanel{width:min(92vw,370px);background:linear-gradient(160deg,#141d33,#0d1426);border:2px solid #3a8dff;border-radius:20px;padding:20px 18px 14px;color:#fff;text-align:center;box-shadow:0 14px 44px rgba(0,0,0,.6)}
#batakTut .btScene{min-height:136px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;margin-bottom:10px}
#batakTut .btRow{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap}
#batakTut .btCard{position:relative;display:inline-flex;flex-direction:column;align-items:center;justify-content:center;width:38px;height:54px;background:#fff;border:1px solid #cfc9ba;border-radius:6px;color:#22283a;box-shadow:0 3px 8px rgba(0,0,0,.45)}
#batakTut .btCard b{font-size:15px;line-height:1}
#batakTut .btCard i{font-style:normal;font-size:15px;line-height:1}
#batakTut .btCard.red{color:#c0392b}
#batakTut .btCard.glow{box-shadow:0 0 0 3px #18c959,0 0 18px rgba(24,201,89,.75)}
#batakTut .btCard.dim{opacity:.4}
#batakTut .btCard.back{background:linear-gradient(145deg,#33415f,#222c45);border-color:#4a5a80}
#batakTut .stack .btCard.back+.btCard.back{margin-left:-26px}
#batakTut .btBubble{min-width:44px;padding:8px 12px;border-radius:16px 16px 16px 4px;background:rgba(255,255,255,.12);border:1.5px solid rgba(255,255,255,.25);font-weight:800;font-size:16px}
#batakTut .btBubble.dim{opacity:.45}
#batakTut .btBubble.win{background:rgba(24,201,89,.2);border-color:#18c959;box-shadow:0 0 14px rgba(24,201,89,.5)}
#batakTut .btSuit{width:44px;height:44px;border-radius:10px;background:#fff;color:#22283a;display:inline-flex;align-items:center;justify-content:center;font-size:26px;box-shadow:0 3px 8px rgba(0,0,0,.45)}
#batakTut .btSuit.red{color:#c0392b}
#batakTut .btSuit.win{box-shadow:0 0 0 3px #18c959,0 0 18px rgba(24,201,89,.75)}
#batakTut .btScore{padding:8px 16px;border-radius:12px;font-weight:800;font-size:15px}
#batakTut .btScore.bad{background:rgba(224,82,82,.15);border:1.5px solid #e05252;color:#ff9a9a}
#batakTut .btScore.good{background:rgba(24,201,89,.15);border:1.5px solid #18c959;color:#7fe3a4}
#batakTut .btSeat{width:40px;height:40px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:19px}
#batakTut .btSeat.teamA{background:rgba(58,123,217,.3);border:2px solid #3a7bd9}
#batakTut .btSeat.teamB{background:rgba(226,72,61,.3);border:2px solid #e2483d}
#batakTut .labels{gap:18px;font-size:11.5px}
#batakTut .lblA{color:#8ab4f8}
#batakTut .lblB{color:#ff9a9a}
#batakTut .btArrow{font-size:22px;color:#FFC833}
#batakTut .btBadge{font-size:12.5px;color:#9ec9ff;background:rgba(58,141,255,.16);border:1px solid rgba(58,141,255,.5);border-radius:14px;padding:4px 12px}
#batakTut .btBadge.gold{color:#ffdf8e;background:rgba(255,200,51,.12);border-color:rgba(255,200,51,.5)}
#batakTut .btTitle{font-size:19px;font-weight:800;color:#7db8ff;margin-bottom:6px}
#batakTut .btText{font-size:13.5px;line-height:1.5;color:#dce8ff;min-height:78px}
#batakTut .btDots{display:flex;justify-content:center;gap:7px;margin:10px 0 12px}
#batakTut .btDots span{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.22);transition:background .2s,transform .2s}
#batakTut .btDots span.on{background:#3a8dff;transform:scale(1.25)}
#batakTut .btNext{width:100%;height:46px;border:none;border-radius:12px;background:linear-gradient(135deg,#18c959,#0f9c42);color:#fff;font-weight:800;font-size:16px;cursor:pointer;font-family:inherit}
#batakTut .btFoot{display:flex;justify-content:space-between;margin-top:10px}
#batakTut .btFoot button{border:none;background:none;color:#7d90b5;font-size:12.5px;cursor:pointer;padding:6px 4px;text-decoration:underline;font-family:inherit}
.batakHowTo{display:block;margin:10px auto 0;height:38px;padding:0 20px;border:1.5px solid rgba(125,184,255,.55);border-radius:19px;background:rgba(20,29,51,.85);color:#7db8ff;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit}
`;

// Lobide masaların altına konur: başlatıcı butonu + modal tek bileşende.
const BatakTutorial = () => {
    const [open, setOpen] = useState(false);
    const [step, setStep] = useState(0);

    // İlk kez oynayanlara otomatik göster (oturum başına bir kez)
    useEffect(() => {
        if (window.__batakTutAutoShown || seen()) return;
        window.__batakTutAutoShown = true;
        setOpen(true);
    }, []);

    const openTut = () => { setStep(0); setOpen(true); };
    const close = () => setOpen(false);
    const next = () => {
        if (step >= STEPS.length - 1) {
            markSeen(); // sonuna kadar izledi → bir daha otomatik çıkmasın
            close();
        } else {
            setStep(step + 1);
        }
    };
    const never = () => { markSeen(); close(); };

    const st = STEPS[step];
    return (
        <>
            <style>{CSS}</style>
            <button type="button" className="batakHowTo" onClick={openTut}>
                📖 Comment jouer ?
            </button>
            {open && (
                <div id="batakTut">
                    <div className="btPanel">
                        <div className="btScene">{st.scene}</div>
                        <div className="btTitle">{st.title}</div>
                        <div className="btText">{st.text}</div>
                        <div className="btDots">
                            {STEPS.map((_, i) => <span key={i} className={i === step ? 'on' : ''} />)}
                        </div>
                        <button type="button" className="btNext" onClick={next}>
                            {step >= STEPS.length - 1 ? 'Jouer !' : 'Suivant'}
                        </button>
                        <div className="btFoot">
                            <button type="button" onClick={close}>Passer</button>
                            <button type="button" onClick={never}>Ne plus afficher</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BatakTutorial;
